import { useEffect, useState } from 'react'
import { getAllHomeTags, getTagsByBoardId } from '../services/tags'
import { useDispatch } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'
import { setBoardTags } from '../store/slice/board-tags-slice'
import { useAuth } from '../modules/auth'
import { setHomeTags } from '../store/slice/home-tags-slice'


const useGetTags: any = (boardIdForTags?: string) => {
    const [tags, setTags] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingBoardTags, setLoadingBoardTags] = useState<boolean>(false)
    const [loadingHomeTags, setLoadingHomeTags] = useState<boolean>(false)
    const dispatch: Dispatch<any> = useDispatch()
    const { currentUser } = useAuth()
    const { id } = currentUser?.data.user

    const getHomeTagsHandler = async () => {
        try {
            setLoadingHomeTags(true)
            const tagRes = await getAllHomeTags(id)
            const tagsData = tagRes?.data?.data?.map((item: any) => {
                return { label: item.name, value: item.name }
            })
            dispatch(setHomeTags(tagsData))
        } catch (error) {
            return error
        } finally {
            setLoadingHomeTags(false)
        }
    }
    const getCardTagByBoardHandler = async (boardId: string) => {
        if (boardId) {
            try {
                setLoadingBoardTags(true)
                const tags = await getTagsByBoardId(boardId, 'card')
                const tagsData = tags?.data?.data?.tags?.map((item: any) => {
                    return { label: item.name, value: item.id, count: item.cardCount }
                })
                dispatch(setBoardTags(tagsData))
            } catch (error) {
                return error
            } finally {
                setLoadingBoardTags(false)
            }
        }
    }
    const getPageTagByBoardHandler = async (boardId: string) => {
        if (boardId) {
            try {
                setLoadingBoardTags(true)
                const tags = await getTagsByBoardId(boardId, 'page')
                const tagsData = tags?.data?.data?.tags?.map((item: any) => {
                    return { label: item.name, value: item.id, count: item.pageCount }
                })
                dispatch(setBoardTags(tagsData))
            } catch (error) {
                return error
            } finally {
                setLoadingBoardTags(false)
            }
        }
    }

    useEffect(() => {
        if (boardIdForTags) {
            const fetchTags = async () => {
                try {
                    setLoading(true)
                    const tagRes = await getTagsByBoardId(boardIdForTags)
                    const tagsData = tagRes?.data?.data?.tags?.map((item: any) => {
                        return { label: item.name, value: item.id }
                    })
                    setTags(tagsData)
                } catch (error) {
                    return error
                } finally {
                    setLoading(false)
                }
            }
            fetchTags()
        }
    }, [boardIdForTags])

    return { tags, loading, getPageTagByBoardHandler, getCardTagByBoardHandler, loadingBoardTags, loadingHomeTags, getHomeTagsHandler }
}

export default useGetTags
